import { render } from "./BFormText.vue?vue&type=template&id=7600f535&ts=true"
import script from "./BFormText.vue?vue&type=script&lang=ts"
export * from "./BFormText.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__